export class StateListItem {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        },
        {
            "name": "tsRelative",
            "baseName": "tsRelative",
            "type": "string",
            "format": ""
        },
        {
            "name": "actor",
            "baseName": "actor",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetPage",
            "baseName": "targetPage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StateListItem.attributeTypeMap;
    }
    constructor() {
    }
}
